import { SxProps } from "@mui/material"

export const sxInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
	width: '100%',
  fontWeight: 400,
  fontSize: '14px',
  minWidth: '230px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    minWidth: 'unset'
  },
}